// extracted by mini-css-extract-plugin
module.exports = {"numberItem":"requirementsimplified_numberItem__3yDVY","descriptionItem":"requirementsimplified_descriptionItem__KmuyI"};